
<section class="card">
  <slot></slot>
</section>
